import { clearSession, getStoredUser } from "./http.service";
const API_URL = (process.env.REACT_APP_API_URL || "") + "/api/auth/";

async function parseError(response: Response): Promise<any> {
  const text = await response.text();
  try {
    return JSON.parse(text);
  } catch {
    return { message: text || "Request failed" };
  }
}

class AuthService {
  login(email: string, password: string): Promise<any> {
    return fetch(API_URL + "signin", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        password,
      }),
    })
      .then(async (response) => {
        if (response.ok) return response.json();
        return Promise.reject(await parseError(response));
      })
      .then((data) => {
        if (data.accessToken) {
          localStorage.setItem("user", JSON.stringify(data));
        }
        return data;
      });
  }

  logout(): void {
    clearSession();
  }

  register(firstName: string, lastName: string, email: string, phoneNumber: string, password: string): Promise<any> {
    return fetch(API_URL + "signup", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        firstName,
        lastName,
        email,
        phoneNumber,
        password,
      }),
    }).then((response) => {
        if (response.ok) {
            return response.json();
        }
        return parseError(response).then((err: any) => Promise.reject(err));
    });
  }

  getCurrentUser(): any {
    return getStoredUser();
  }
}

const authService = new AuthService();
export default authService;
